type ControlRule = {
  list_name_prefix: string;
  list_id_suffix: string;
};

const controlRulesById: Record<string, ControlRule> = {
  '16': {
    list_name_prefix: 'Business rule',
    list_id_suffix: 'business',
  },
  '18': {
    list_name_prefix: 'Business rule',
    list_id_suffix: 'business',
  },
  '20': {
    list_name_prefix: 'Business rule',
    list_id_suffix: 'business',
  },
  '21': {
    list_name_prefix: 'Business rule',
    list_id_suffix: 'business',
  },
  '23': {
    list_name_prefix: 'Business rule',
    list_id_suffix: 'business',
  },
  '25': {
    list_name_prefix: 'Business rule',
    list_id_suffix: 'business',
  },
  '53': {
    list_name_prefix: 'Business rule',
    list_id_suffix: 'business',
  },
  '54': {
    list_name_prefix: 'Business rule',
    list_id_suffix: 'business',
  },
  '57': {
    list_name_prefix: 'Business rule',
    list_id_suffix: 'business',
  },
  '74': {
    list_name_prefix: 'Business rule',
    list_id_suffix: 'business',
  },
  '90': {
    list_name_prefix: 'Business rule',
    list_id_suffix: 'business',
  },
  '96': {
    list_name_prefix: 'Business rule',
    list_id_suffix: 'business',
  },
  '98': {
    list_name_prefix: 'Business rule',
    list_id_suffix: 'business',
  },
  '109': {
    list_name_prefix: 'Business rule',
    list_id_suffix: 'business',
  },
  '124': {
    list_name_prefix: 'Business rule',
    list_id_suffix: 'business',
  },
  '160': {
    list_name_prefix: 'Business rule',
    list_id_suffix: 'business',
  },
  '180': {
    list_name_prefix: 'Business rule',
    list_id_suffix: 'business',
  },
  '183': {
    list_name_prefix: 'Business rule',
    list_id_suffix: 'business',
  },
  '187': {
    list_name_prefix: 'Business rule',
    list_id_suffix: 'business',
  },
  '156': {
    list_name_prefix: 'Lead limit',
    list_id_suffix: 'lead_limit',
  },
  '157': {
    list_name_prefix: 'Lead limit',
    list_id_suffix: 'lead_limit',
  },
  '169': {
    list_name_prefix: 'Lead limit',
    list_id_suffix: 'lead_limit',
  },
  '19': {
    list_name_prefix: 'Location',
    list_id_suffix: 'location',
  },
  '136': {
    list_name_prefix: 'Location',
    list_id_suffix: 'location',
  },
  '30': {
    list_name_prefix: 'No commercial',
    list_id_suffix: 'no_comm',
  },
  '179': {
    list_name_prefix: 'No commercial',
    list_id_suffix: 'no_comm',
  },
  '184': {
    list_name_prefix: 'No commercial',
    list_id_suffix: 'no_comm',
  },
  '27': {
    list_name_prefix: 'No residential',
    list_id_suffix: 'no_res',
  },
  '56': {
    list_name_prefix: 'No residential',
    list_id_suffix: 'no_res',
  },
  '76': {
    list_name_prefix: 'No residential',
    list_id_suffix: 'no_res',
  },
  '77': {
    list_name_prefix: 'No residential',
    list_id_suffix: 'no_res',
  },
  '78': {
    list_name_prefix: 'No residential',
    list_id_suffix: 'no_res',
  },
  '79': {
    list_name_prefix: 'No residential',
    list_id_suffix: 'no_res',
  },
  '80': {
    list_name_prefix: 'No residential',
    list_id_suffix: 'no_res',
  },
  '84': {
    list_name_prefix: 'No residential',
    list_id_suffix: 'no_res',
  },
  '86': {
    list_name_prefix: 'No residential',
    list_id_suffix: 'no_res',
  },
  '99': {
    list_name_prefix: 'No residential',
    list_id_suffix: 'no_res',
  },
  '101': {
    list_name_prefix: 'No residential',
    list_id_suffix: 'no_res',
  },
  '102': {
    list_name_prefix: 'No residential',
    list_id_suffix: 'no_res',
  },
  '104': {
    list_name_prefix: 'No residential',
    list_id_suffix: 'no_res',
  },
  '116': {
    list_name_prefix: 'No residential',
    list_id_suffix: 'no_res',
  },
  '123': {
    list_name_prefix: 'No residential',
    list_id_suffix: 'no_res',
  },
  '134': {
    list_name_prefix: 'No residential',
    list_id_suffix: 'no_res',
  },
  '135': {
    list_name_prefix: 'No residential',
    list_id_suffix: 'no_res',
  },
  '138': {
    list_name_prefix: 'No residential',
    list_id_suffix: 'no_res',
  },
  '139': {
    list_name_prefix: 'No residential',
    list_id_suffix: 'no_res',
  },
  '140': {
    list_name_prefix: 'No residential',
    list_id_suffix: 'no_res',
  },
  '141': {
    list_name_prefix: 'No residential',
    list_id_suffix: 'no_res',
  },
  '144': {
    list_name_prefix: 'No residential',
    list_id_suffix: 'no_res',
  },
  '161': {
    list_name_prefix: 'No residential',
    list_id_suffix: 'no_res',
  },
  '162': {
    list_name_prefix: 'No residential',
    list_id_suffix: 'no_res',
  },
  '163': {
    list_name_prefix: 'No residential',
    list_id_suffix: 'no_res',
  },
  '164': {
    list_name_prefix: 'No residential',
    list_id_suffix: 'no_res',
  },
  '171': {
    list_name_prefix: 'No residential',
    list_id_suffix: 'no_res',
  },
  '172': {
    list_name_prefix: 'No residential',
    list_id_suffix: 'no_res',
  },
  '176': {
    list_name_prefix: 'No residential',
    list_id_suffix: 'no_res',
  },
  '181': {
    list_name_prefix: 'No residential',
    list_id_suffix: 'no_res',
  },
  '185': {
    list_name_prefix: 'No residential',
    list_id_suffix: 'no_res',
  },
  '186': {
    list_name_prefix: 'No residential',
    list_id_suffix: 'no_res',
  },
  '188': {
    list_name_prefix: 'No residential',
    list_id_suffix: 'no_res',
  },
  '189': {
    list_name_prefix: 'No residential',
    list_id_suffix: 'no_res',
  },
  '190': {
    list_name_prefix: 'No residential',
    list_id_suffix: 'no_res',
  },
  '12': {
    list_name_prefix: 'Out of stock',
    list_id_suffix: 'oos',
  },
  '97': {
    list_name_prefix: 'Out of stock',
    list_id_suffix: 'oos',
  },
  '100': {
    list_name_prefix: 'Out of stock',
    list_id_suffix: 'oos',
  },
  '34': {
    list_name_prefix: 'Persona',
    list_id_suffix: 'persona',
  },
  '39': {
    list_name_prefix: 'Persona',
    list_id_suffix: 'persona',
  },
  '51': {
    list_name_prefix: 'Persona',
    list_id_suffix: 'persona',
  },
  '59': {
    list_name_prefix: 'Persona',
    list_id_suffix: 'persona',
  },
  '60': {
    list_name_prefix: 'Persona',
    list_id_suffix: 'persona',
  },
  '61': {
    list_name_prefix: 'Persona',
    list_id_suffix: 'persona',
  },
  '62': {
    list_name_prefix: 'Persona',
    list_id_suffix: 'persona',
  },
  '81': {
    list_name_prefix: 'Persona',
    list_id_suffix: 'persona',
  },
  '112': {
    list_name_prefix: 'Persona',
    list_id_suffix: 'persona',
  },
  '119': {
    list_name_prefix: 'Persona',
    list_id_suffix: 'persona',
  },
  '165': {
    list_name_prefix: 'Persona',
    list_id_suffix: 'persona',
  },
  '168': {
    list_name_prefix: 'Persona',
    list_id_suffix: 'persona',
  },
  '175': {
    list_name_prefix: 'Persona',
    list_id_suffix: 'persona',
  },
  '182': {
    list_name_prefix: 'Persona',
    list_id_suffix: 'persona',
  },
};

export default controlRulesById;
